import { Col, Row } from "antd";
import { IOption } from "../../../../../../../../../types/Option";
import { getFormattedCurrency } from "../../../../../../../../../lib/currencyFormatter";
import { useMemo } from "react";

type DataChildRowProps = {
  data: IOption;
  values: any;
  higlight: boolean;
};

export const DataChildRow = ({ data, values, higlight }: DataChildRowProps) => {
  const value: string = useMemo(
    () => getFormattedCurrency(values[data.value] || 0),
    [data.value, values]
  );

  return (
    <Row className={`p${higlight ? "x" : "r"}-4 align-center mb-1`}>
      <Col
        span={higlight ? 14 : 12}
        className={`d-flex ${higlight ? "justify-end" : ""}`}
      >
        <p className="my-0 text-sm title">{data.label}</p>
      </Col>
      <Col span={higlight ? 10 : 12} className="d-flex justify-end">
        <p className="my-0 ml-2 text-sm w-500 elipsis" title={value}>
          {value}
        </p>
      </Col>
    </Row>
  );
};
